import styled, { css } from 'styled-components';
import { Text, TextButton as TextButton$1, Icon } from '@amzn/storm-ui';

const LabelText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-40018696__sc-cpovnh-0"
})(["margin-inline-end:3px;"]);
const TextButtonStyles = /*#__PURE__*/css(["display:flex;justify-content:center;align-items:center;gap:", ";"], ({
  theme
}) => theme.spacing.xxxsmall.default);
const TextButton = /*#__PURE__*/styled(TextButton$1).withConfig({
  componentId: "sc-storm-ui-40018696__sc-cpovnh-1"
})(["border-radius:", ";", ""], ({
  theme
}) => theme.border.radius.round, TextButtonStyles);
const TextButtonIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40018696__sc-cpovnh-2"
})(["color:", ";"], ({
  theme
}) => theme.color.gray[800]);

export { LabelText as L, TextButton as T, TextButtonIcon as a };
//# sourceMappingURL=TextButtonPopoverAttribute.styles-DiEDyrYt.js.map
